import deck_configuration from './deck_configuration.json'
import protocol_command_text from './protocol_command_text.json'

export const shared_zh_resources = {
  deck_configuration,
  protocol_command_text,
}
